<template>
    <div class="consolidationPopup">
        <confirmation-dialog @confirmYes="confirmConsolidate()" />

        <v-dialog v-model="isConsolidationPopup" scrollable max-width="500px" @input="closed()">
            <v-card>
                <v-card-title><h3 class="h3text">Consolidation</h3> </v-card-title>
                <v-divider />
                <v-card-text>
                    <h5>Please select one of the records to be kept after consolidation.</h5>
                    <p class="warningPhrase"> ** Warning! The rest of the records will be merged and deleted upon consolidation!</p>
                    <v-radio-group v-model="radioGroup"
                                   v-validate="'required'" 
                                   :error-messages="errors.collect('Radio Button')" data-vv-name="Radio Button"
                    >
                        <v-radio v-for="(n,index) in ids" :key="n.id"
                                 color="dark-green"
                                 class="vRadio"
                                 :label="`${n.id} - ${n.name}`"
                                 :value="n.id"
                                 required
                        />
                    </v-radio-group>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-layout column wrap sm-side-padding>
                        <v-flex class="vFlex sm-side-padding">
                            <v-text-field v-model="confirmId" v-validate="'required'" class="textField" 
                                          outline
                                          label="Confirmation ID" 
                                          placeholder="Please enter the ID to confirm * " 
                                          :hint="'If you select &#34;' + selectedName + '&#34;, just enter ID &#34;' + radioGroup + '&#34;.'" 
                                          :error-messages="errors.collect('Confirmation ID')" data-vv-name="Confirmation ID"
                                          mask="#######" 
                                          persistent-hint required
                            />
                        </v-flex>

                        <v-flex class="vFlex sm-side-padding">
                            <div class="buttons">
                                <v-btn type="button" outline color="primary" @click="closed()">Cancel</v-btn>
                                <v-btn type="button" outline color="primary" @click="save()">Save</v-btn>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
const config = {
    fieldsBagName: "fieldBags",
};
Vue.use(VeeValidate, config);

export default {
    props: ["comfirmFn"],
    data () {
        return {
            radioGroup: 0,
            isConsolidationPopup: false,
            ids: "",
            getDropdownAPIName: "",
            consolidateAPIName: "",
            tableName: "",
            confirmId: "",
            tempOption: [],
            firstOption: [{ id: "", name: "" }],
            selectedName: "",
        };
    },
    watch: {
        ids() {
            this.getAllForDropdownCnsldt();
        },
        radioGroup() {
            var self = this;

            self.errors.clear();

            // dynamic hint example
            if (self.radioGroup !== 0) {
                self.ids.forEach(function(item) {						
                    if (item.id == self.radioGroup) {
                        self.selectedName = item.name;
                    }
                });
            }
        }
    },
    mounted() {
        var self = this;
        EventBus.$on("consolidateDialog", function (object) {
            self.isConsolidationPopup = object.isConsolidationPopup;
            self.ids           		  = object.ids;
            self.getDropdownAPIName   = object.getDropdownAPIName;
            self.consolidateAPIName	  = object.consolidateAPIName;
            self.tableName    		  = object.tableName;
        });
    },
    methods: {
        save() {
            // if radio button is not selected
            if (!this.radioGroup) {
                EventBus.$emit("snackBar", {
                    text: "Please select a record to be merged!",
                    snackbarColor: "amber darken-2"
                });

            }

            this.$validator.validateAll().then(result => {
                if (result) {						
                    if (this.radioGroup) {
                        if (this.confirmId === this.radioGroup) {
                            EventBus.$emit("confirmDialog", {
					              text: "Are you sure to consolidate this record? ",
					            });
                        }
                        else {
                            EventBus.$emit("snackBar", {
                                text: "Error! Unmatched IDs. The confirmation ID should match the ID of the selection!",
                                snackbarColor: "red lighten-1"
                            });
                        }
                    }
                }
            });
        },
        closed() {
            if (this.isConsolidationPopup) {
                this.isConsolidationPopup = false;
            }
            this.errors.clear();
            this.radioGroup = 0;
            this.confirmId = "";
        },
        getAllForDropdownCnsldt() {
            var self = this;
            axios({
                method: "GET",
                url: this.getDropdownAPIName,
            })
                .then(function (response) {
                    self.tempOption = response.data.result;
					
                    // map the name to the name-lacking object in ids
                    self.ids.forEach(function(item) {
                        self.tempOption.forEach(option => {
                            if (item.id == option.id) {									
                                item.name = option.name;
                            }
                        });
                    });

                    // default hint example
                    self.selectedName = self.ids[0].name;
                    self.radioGroup = self.ids[0].id;
                });
        },
        confirmConsolidate() {
            var self = this;

            var saveIDs = [];
            self.ids.forEach(function(item) {
                // remove idToKeep from the idsToMerge list
                if (item.id !== self.confirmId) {
                    saveIDs.push(item.id);
                }
            });

            axios({
                method: "POST",
                url: self.consolidateAPIName,
                data: {
                    idToKeep: self.confirmId,
                    idsToMerge: saveIDs,
                }
            })
                .then(function (response) {
					
                    self.closed();					
                    self.reloadTable(self.tableName);

                    EventBus.$emit("snackBar", {
                        text: "Consolidated Successfully!",
                        snackbarColor: "green darken-2"
                    });
                });
        }
    }
};
</script>
<style scoped>
.textField{
	width:100%;
	margin:auto;
	padding-top: 15px;
}
.buttons{
	padding: 1rem 0;
	float:right;
}
.v-divider{
	margin:0;
}
.h3text{
	margin:0;
	padding: 0 1.625rem;
}
.v-card__text{
	padding: 2rem 3rem;
}
.vFlex{
    padding: 0 3rem;
}
.warningPhrase{
	font-size: 0.8rem;
	color: red;
}
.vRadio >>> label{
	margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/smallComponents/consolidationPopup.vue